import { CellGroup, Cell, ActionSheet, Checkbox, CheckboxGroup } from 'vant'
import { formatDate } from 'Utils/dateUtil'
import { getSysType } from '@/common/utils/plus'
// import ldUploader from 'Components/ldUploader'

export default {
  name:'HtRefund',
  components: {
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [ActionSheet.name]: ActionSheet,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    ldButton: () => import('Common/ldButton'),
    MescrollVue: () => import('mescroll.js/mescroll.vue'),
    // ldUploader
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      detail: {}, // 正常单详情
      is_action_sheet: false,
      actions: [],
      /**
       * 生成退单模型
       */
      model: {
        orderFrom: getSysType(), // 订单来源
        orderId: '', // 酒店订单id
        orderPrices: '', // 订单价格ids
        vipRefundReason: '' // 企业退房理由
      }
    }
  },
  created() {
    /**
     * 初始化
     */
    this.model.orderId = this.id
    this.loadData()
  },
  methods: {
    loadData() {
      this.$api['htQuery/applyHotelRefund']({
        orderId : this.id
      }).then(res => {
        /**
         * 初始化
         */
        res.data.orderRooms.forEach(element => {
          element.checked = true
          element.prices.forEach(element_ => {
            element_.checked = true
          })
        })
        this.detail = res.data
        this.detail.orderType = $dict.ORDER_TYPE.hotel.refund
        this.detail._rzrqweek = formatDate(this.detail.rzrq).week
        this.detail._ldrqweek = formatDate(this.detail.ldrq).week
      }).catch(() => {})
    },
    refundReason() {
      if (!this.actions.length) {
        this.$api['common/getBClass']({
          // parNo : '144'
          parNo : '11602041'
        }).then(res => {
          this.actions = []
          res.data.list.forEach(element => {
            this.actions.push({
              name: element.cName,
              value: element.id,
              checked: false
            })
          })
          this.is_action_sheet = true
        }).catch(() => {})
      } else {
        this.is_action_sheet = true
      }
    },
    /**
     * 选择房型
     */
    onSelect(item) {
      this.actions.forEach(element => {
        element.checked = false
      })
      item.checked = true
      this.is_action_sheet = false
      this.model.vipRefundReason = item.name
    },
    checkeditems(item, type) {
      item.checked = type
      item.prices.forEach(element => {
        element.checked = type
      })
    },
    checkeditem(item, type, type_) { 
      if (!type_) {
        return item.checked = false
      } else {
        setTimeout(() => {
          let isChecked = false
          item.prices.forEach(element => {
            if (!element.checked) isChecked = true
          })
          if (!isChecked) return item.checked = true
        }, 0)
      }
    },
    /**
     * 提交申请
     */
    submit() {
      if (!this.model.vipRefundReason) return this.$toast('请选择退房原因！')
      let orderPrices_ = []
      this.detail.orderRooms && this.detail.orderRooms.forEach(element => {
        element.prices.length && element.prices.forEach(element_ => {
          element_.checked && element_.status == '0' && orderPrices_.push(element_.id)
        })
      })
      this.model.orderPrices = orderPrices_.join()
      if (!this.model.orderPrices) return this.$toast('请至少选择一个房间！')
      this.$api['htQuery/hotelRefundAdd'](this.model).then(res => {
        res.data && res.data.htRefundId && this.$router.push({ path: '/ht/htRefundComplete/'+res.data.htRefundId+''}) 
      }).catch(() => {})
    },
    add(arg1, arg2) {
      return (Math.round(arg1 * 100) + Math.round(arg2 * 100)) / 100
    }
  }
}